import { Box, styled } from "@mui/material";

export const ChipsListContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
`;
